import { useLocation } from 'react-router-dom';

import { Row } from 'antd';
import dayjs from 'dayjs';

import programConfig from '@/config/programs/formFields';
import { isOctaPharmaProgram } from '@/libs/util';

import FormField from './FormField';

interface ProgramFormProps {
  programName: string;
  disabled?: boolean;
  disabledFields?: string[];
  hiddenFields?: string[];
  icdCodeNames: string[];
  meData: any;
}

const ProgramForm = ({
  programName,
  disabled = false,
  disabledFields = [],
  hiddenFields = [],
  icdCodeNames,
  meData,
}: ProgramFormProps) => {
  const config = programConfig[programName as keyof typeof programConfig];
  const pathname = useLocation().pathname;
  const editMode = pathname.includes('edit');

  if (!config) {
    console.error(`No configuration found for program: ${programName}`);
    return null;
  }

  let visibleFields =
    hiddenFields.length > 0
      ? config.fields.filter((field) => !hiddenFields.includes(field.name))
      : config.fields;

  const isOctaPharma = isOctaPharmaProgram(programName);

  if (isOctaPharma && editMode) {
    visibleFields = visibleFields.map((field) => {
      if (field.name === 'expected_dispensing_date') {
        return {
          ...field,
          disabledDate: (current: any) => {
            const currentYear = dayjs().year();
            return current && current.year() !== currentYear;
          },
        };
      }
      return field;
    });
  }

  return (
    <Row
      gutter={20}
      style={{
        width: '100%',
        margin: 0,
        pageBreakInside: 'avoid',
      }}
    >
      {visibleFields.map((field) => (
        <FormField
          key={field.name}
          field={field}
          disabled={disabledFields.includes(field.name) || disabled}
          icdCodeNames={icdCodeNames}
          meData={meData}
        />
      ))}
    </Row>
  );
};

export default ProgramForm;
